/** Параметри бази лічильника «N з M»: відбір списку без умов швидких полів. Чиста функція. */
import type { IRecordListParams } from '@platform/core/types';
import { quickFieldsDsl } from './quickFieldFilters';
import { withoutPart } from './quickBase';

export function quickBase(params: IRecordListParams, quick: Readonly<Record<string, string>>): IRecordListParams {
  const filter = withoutPart(params.filter, quickFieldsDsl(quick));
  const { filter: _f, ...rest } = params;
  return filter ? { ...rest, filter } : rest;
}
